module.exports = __webpack_public_path__ + "static/media/gps.694bee20.svg";